const formatAdditionalContactDetails = (set, contactDetailTypes) => {
  const formats = {
    link: 'url',
    date: 'date',
  };
  return set
    .filter((n) => n.category === 'contactDetail')
    .map((n) => {
      const type = contactDetailTypes.find((o) => o.id === n.detailTypeId);
      const subType = ((type || {}).sub_types || []).find((o) => o.id === n.detailSubTypeId);
      return {
        ...n,
        type,
        subType,
        format: formats[(type || {}).type] || undefined,
      };
    });
};

export default formatAdditionalContactDetails;
